export default __webpack_public_path__ + "static/media/pp-bg-s-final.437a623f.png";